import { Grid } from '@chakra-ui/react'
import type { Statistics } from 'BrokerTsLib/src/dtos'
import { priceFormat } from 'BrokerTsLib/src/Utils/formatPrice'
import { StatCard } from './StatCard'
import { StatChangeValue } from './StatChangeValue'
import { StatValue } from './StatValue'

interface MainStatsGridProps {
  stats: Statistics;
  adjustedPreviousStats: Statistics;
  isLoadingStats: boolean;
  adjustedPreviousTimeRangeLabel: string;
  previousTimeRangeLabel: string;
}

export const MainStatsGrid = ({
  stats,
  adjustedPreviousStats,
  isLoadingStats,
  adjustedPreviousTimeRangeLabel,
  previousTimeRangeLabel
}: MainStatsGridProps) => {
  return (
    <Grid
      sx={{
        alignContent: 'stretch',
        gridTemplateColumns: { base: '1fr 1fr', lg: '1fr' },
        gap: 4,
      }}
    >
      <StatCard label='Předepsané pojistné'>
        <StatValue isLoading={isLoadingStats} fontSize='4xl'>
          {priceFormat(stats.predepanePojistne, undefined, '0 Kč')}
        </StatValue>
        <StatChangeValue
          isLoading={isLoadingStats}
          value={stats.predepanePojistne ?? 0}
          baselineValue={adjustedPreviousStats.predepanePojistne ?? 0}
          baselineValueLabel={adjustedPreviousTimeRangeLabel}
        />
      </StatCard>

      <StatCard label='Průměrná výše pojistného'>
        <StatValue isLoading={isLoadingStats} fontSize='2xl'>
          {priceFormat(stats.predepanePojistne / stats.pocetSmluv)}
        </StatValue>
        <StatChangeValue
          isLoading={isLoadingStats}
          value={stats.predepanePojistne / stats.pocetSmluv}
          baselineValue={adjustedPreviousStats.predepanePojistne / adjustedPreviousStats.pocetSmluv}
          baselineValueLabel={previousTimeRangeLabel}
        />
      </StatCard>
    </Grid>
  )
}
